import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

export async function fetchMiscPurchaseOrderDetail(id) {
  const { data: raw } = await request.get(`/srm/misc-purchase-order/${id}`);
  return parseVer4DetailResponse(raw);
}
